/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateLandingFolderRestrictionDto } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { LFREntity } from '../models';
// @ts-ignore
import { UpdateLandingFolderRestrictionDto } from '../models';
/**
 * LandingFolderRestrictionApi - axios parameter creator
 * @export
 */
export const LandingFolderRestrictionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new landing folder restriction
         * @param {CreateLandingFolderRestrictionDto} createLandingFolderRestrictionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLandingFolderRestriction: async (createLandingFolderRestrictionDto: CreateLandingFolderRestrictionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLandingFolderRestrictionDto' is not null or undefined
            assertParamExists('createLandingFolderRestriction', 'createLandingFolderRestrictionDto', createLandingFolderRestrictionDto)
            const localVarPath = `/api/v1.0/landing-folder-restrictions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLandingFolderRestrictionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a landing folder restriction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLandingFolderRestriction: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLandingFolderRestriction', 'id', id)
            const localVarPath = `/api/v1.0/landing-folder-restrictions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find landing folder restrictions by folder name
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLandingFolderByFolderRestrictionName: async (folder: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('findLandingFolderByFolderRestrictionName', 'folder', folder)
            const localVarPath = `/api/v1.0/landing-folder-restrictions/folder/{folder}`
                .replace(`{${"folder"}}`, encodeURIComponent(String(folder)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all landing folder restrictions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLandingFolders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/landing-folder-restrictions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get landing folder restriction by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingFolderRestrictionById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLandingFolderRestrictionById', 'id', id)
            const localVarPath = `/api/v1.0/landing-folder-restrictions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a landing folder restriction
         * @param {string} id 
         * @param {UpdateLandingFolderRestrictionDto} updateLandingFolderRestrictionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandingFolderRestriction: async (id: string, updateLandingFolderRestrictionDto: UpdateLandingFolderRestrictionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLandingFolderRestriction', 'id', id)
            // verify required parameter 'updateLandingFolderRestrictionDto' is not null or undefined
            assertParamExists('updateLandingFolderRestriction', 'updateLandingFolderRestrictionDto', updateLandingFolderRestrictionDto)
            const localVarPath = `/api/v1.0/landing-folder-restrictions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLandingFolderRestrictionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandingFolderRestrictionApi - functional programming interface
 * @export
 */
export const LandingFolderRestrictionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LandingFolderRestrictionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new landing folder restriction
         * @param {CreateLandingFolderRestrictionDto} createLandingFolderRestrictionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLandingFolderRestriction(createLandingFolderRestrictionDto: CreateLandingFolderRestrictionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LFREntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLandingFolderRestriction(createLandingFolderRestrictionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a landing folder restriction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLandingFolderRestriction(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LFREntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLandingFolderRestriction(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find landing folder restrictions by folder name
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLandingFolderByFolderRestrictionName(folder: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LFREntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLandingFolderByFolderRestrictionName(folder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all landing folder restrictions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLandingFolders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LFREntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLandingFolders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get landing folder restriction by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandingFolderRestrictionById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LFREntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLandingFolderRestrictionById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a landing folder restriction
         * @param {string} id 
         * @param {UpdateLandingFolderRestrictionDto} updateLandingFolderRestrictionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLandingFolderRestriction(id: string, updateLandingFolderRestrictionDto: UpdateLandingFolderRestrictionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LFREntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLandingFolderRestriction(id, updateLandingFolderRestrictionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LandingFolderRestrictionApi - factory interface
 * @export
 */
export const LandingFolderRestrictionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LandingFolderRestrictionApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new landing folder restriction
         * @param {CreateLandingFolderRestrictionDto} createLandingFolderRestrictionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLandingFolderRestriction(createLandingFolderRestrictionDto: CreateLandingFolderRestrictionDto, options?: any): AxiosPromise<LFREntity> {
            return localVarFp.createLandingFolderRestriction(createLandingFolderRestrictionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a landing folder restriction
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLandingFolderRestriction(id: string, options?: any): AxiosPromise<LFREntity> {
            return localVarFp.deleteLandingFolderRestriction(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find landing folder restrictions by folder name
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLandingFolderByFolderRestrictionName(folder: string, options?: any): AxiosPromise<Array<LFREntity>> {
            return localVarFp.findLandingFolderByFolderRestrictionName(folder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all landing folder restrictions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLandingFolders(options?: any): AxiosPromise<Array<LFREntity>> {
            return localVarFp.getAllLandingFolders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get landing folder restriction by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingFolderRestrictionById(id: string, options?: any): AxiosPromise<LFREntity> {
            return localVarFp.getLandingFolderRestrictionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a landing folder restriction
         * @param {string} id 
         * @param {UpdateLandingFolderRestrictionDto} updateLandingFolderRestrictionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandingFolderRestriction(id: string, updateLandingFolderRestrictionDto: UpdateLandingFolderRestrictionDto, options?: any): AxiosPromise<LFREntity> {
            return localVarFp.updateLandingFolderRestriction(id, updateLandingFolderRestrictionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createLandingFolderRestriction operation in LandingFolderRestrictionApi.
 * @export
 * @interface LandingFolderRestrictionApiCreateLandingFolderRestrictionRequest
 */
export interface LandingFolderRestrictionApiCreateLandingFolderRestrictionRequest {
    /**
     * 
     * @type {CreateLandingFolderRestrictionDto}
     * @memberof LandingFolderRestrictionApiCreateLandingFolderRestriction
     */
    readonly createLandingFolderRestrictionDto: CreateLandingFolderRestrictionDto
}

/**
 * Request parameters for deleteLandingFolderRestriction operation in LandingFolderRestrictionApi.
 * @export
 * @interface LandingFolderRestrictionApiDeleteLandingFolderRestrictionRequest
 */
export interface LandingFolderRestrictionApiDeleteLandingFolderRestrictionRequest {
    /**
     * 
     * @type {string}
     * @memberof LandingFolderRestrictionApiDeleteLandingFolderRestriction
     */
    readonly id: string
}

/**
 * Request parameters for findLandingFolderByFolderRestrictionName operation in LandingFolderRestrictionApi.
 * @export
 * @interface LandingFolderRestrictionApiFindLandingFolderByFolderRestrictionNameRequest
 */
export interface LandingFolderRestrictionApiFindLandingFolderByFolderRestrictionNameRequest {
    /**
     * 
     * @type {string}
     * @memberof LandingFolderRestrictionApiFindLandingFolderByFolderRestrictionName
     */
    readonly folder: string
}

/**
 * Request parameters for getLandingFolderRestrictionById operation in LandingFolderRestrictionApi.
 * @export
 * @interface LandingFolderRestrictionApiGetLandingFolderRestrictionByIdRequest
 */
export interface LandingFolderRestrictionApiGetLandingFolderRestrictionByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof LandingFolderRestrictionApiGetLandingFolderRestrictionById
     */
    readonly id: string
}

/**
 * Request parameters for updateLandingFolderRestriction operation in LandingFolderRestrictionApi.
 * @export
 * @interface LandingFolderRestrictionApiUpdateLandingFolderRestrictionRequest
 */
export interface LandingFolderRestrictionApiUpdateLandingFolderRestrictionRequest {
    /**
     * 
     * @type {string}
     * @memberof LandingFolderRestrictionApiUpdateLandingFolderRestriction
     */
    readonly id: string

    /**
     * 
     * @type {UpdateLandingFolderRestrictionDto}
     * @memberof LandingFolderRestrictionApiUpdateLandingFolderRestriction
     */
    readonly updateLandingFolderRestrictionDto: UpdateLandingFolderRestrictionDto
}

/**
 * LandingFolderRestrictionApi - object-oriented interface
 * @export
 * @class LandingFolderRestrictionApi
 * @extends {BaseAPI}
 */
export class LandingFolderRestrictionApi extends BaseAPI {
    /**
     * 
     * @summary Create a new landing folder restriction
     * @param {LandingFolderRestrictionApiCreateLandingFolderRestrictionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingFolderRestrictionApi
     */
    public createLandingFolderRestriction(requestParameters: LandingFolderRestrictionApiCreateLandingFolderRestrictionRequest, options?: AxiosRequestConfig) {
        return LandingFolderRestrictionApiFp(this.configuration).createLandingFolderRestriction(requestParameters.createLandingFolderRestrictionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a landing folder restriction
     * @param {LandingFolderRestrictionApiDeleteLandingFolderRestrictionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingFolderRestrictionApi
     */
    public deleteLandingFolderRestriction(requestParameters: LandingFolderRestrictionApiDeleteLandingFolderRestrictionRequest, options?: AxiosRequestConfig) {
        return LandingFolderRestrictionApiFp(this.configuration).deleteLandingFolderRestriction(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find landing folder restrictions by folder name
     * @param {LandingFolderRestrictionApiFindLandingFolderByFolderRestrictionNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingFolderRestrictionApi
     */
    public findLandingFolderByFolderRestrictionName(requestParameters: LandingFolderRestrictionApiFindLandingFolderByFolderRestrictionNameRequest, options?: AxiosRequestConfig) {
        return LandingFolderRestrictionApiFp(this.configuration).findLandingFolderByFolderRestrictionName(requestParameters.folder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all landing folder restrictions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingFolderRestrictionApi
     */
    public getAllLandingFolders(options?: AxiosRequestConfig) {
        return LandingFolderRestrictionApiFp(this.configuration).getAllLandingFolders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get landing folder restriction by ID
     * @param {LandingFolderRestrictionApiGetLandingFolderRestrictionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingFolderRestrictionApi
     */
    public getLandingFolderRestrictionById(requestParameters: LandingFolderRestrictionApiGetLandingFolderRestrictionByIdRequest, options?: AxiosRequestConfig) {
        return LandingFolderRestrictionApiFp(this.configuration).getLandingFolderRestrictionById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a landing folder restriction
     * @param {LandingFolderRestrictionApiUpdateLandingFolderRestrictionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingFolderRestrictionApi
     */
    public updateLandingFolderRestriction(requestParameters: LandingFolderRestrictionApiUpdateLandingFolderRestrictionRequest, options?: AxiosRequestConfig) {
        return LandingFolderRestrictionApiFp(this.configuration).updateLandingFolderRestriction(requestParameters.id, requestParameters.updateLandingFolderRestrictionDto, options).then((request) => request(this.axios, this.basePath));
    }
}
